import { z } from 'zod';
export default {
  valueType: 'timestamp',
  valueValidator: z.preprocess(val => {
    if (val == null || val instanceof Date) {
      return val;
    }
    return new Date(val);
  }, z.date().optional().nullable())
};